<template>
  <tbody>
    <tr v-for="(lot, i) in rows" :key="i">
      <td class="text-center white-space-nowrap">
        {{ lot.name }}
      </td>
      <template v-for="(ribbonData, week) in columns">
        <template v-for="ribbon in ribbonData">
          <td class="text-center">
            {{ getNumberClusters(week, lot.numberLot, ribbon['color_name']) }}
          </td>
        </template>
      </template>
      <td class="text-center">
        <strong style="font-size: 16px">
          {{ getTotalRow(lot.numberLot) }}
        </strong>
      </td>
    </tr>
  </tbody>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';

export default {
  name: 'tbody-by-age-week',
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    data: {
      type: Array | Object,
      default: () => {
        return [];
      },
    },
    totalRows: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'reportByAgeAndWeek',
    },
  },
  mixins: [MixinMasters],
  methods: {
    getNumberClusters(week, lot, ribbon) {
      const array = [];
      try {
        array.push(
          this.data['cutting'][week][lot].filter(
            (obj) => obj.color_name === ribbon
          )
        );
      } catch (error) {
        array.push([0]);
      }

      const cutting = getSumOfValorFromArray(
        array[0].map((data) => data.number_clusters)
      );

      return Number(cutting) === 0 ? '' : Formatter.formatNumber(cutting);
    },

    getTotalRow(lot) {
      let sum = '';
      try {
        sum = getSumOfValorFromArray(this.totalRows[lot]);
      } catch (error) {}

      return Formatter.formatNumber(sum);
    },
  },
};
</script>
